app.service('DistrictService', function (ApiService, $rootScope) {

    //Get Single District
    this.getDistrict = function (id, lang, lang2, index, sortKey, reverse) {
        return ApiService.get("/api/District/GetDistrictTranslation?id=" + id + "&lang=" + lang + "&lang2=" + lang2 + "&index=" + index + "&sortKey=" + sortKey + "&reverse=" + reverse);
    }

    this.GetDistrictList = function (zoneId, itemsPerPage, pagenumber, sortKey, reverse, lang, isTopBarActive, sparams, sgparams, searchText, AdvancedSearch) {
        var request = ApiService.post("/api/District/GetDistrictList?zoneId=" + zoneId + "&itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang + "&itba=" + isTopBarActive + "&sparams=" + sparams + "&sgparams=" + sgparams + "&st=" + encodeURIComponent(searchText), AdvancedSearch);
        return request;
    }

    //Update  
    this.UpdateDistrict = function (District) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/District/UpdateDistrictTranslation", District)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }



    //Update Description 
    this.UpdateDescription = function (District) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/District/UpdateDescriptionTranslation", District)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update Description 
    this.UpdateDescriptionStatus = function (District) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/District/UpdateDescriptionTranslationStatus", District)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update Description  status
    this.UpdateDistrictStatus = function (status, objectId, lang) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/District/UpdateDistrictStatus?id=" + objectId + "&status=" + status + "&lang=" + lang)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }


    //Update Description 
    this.TranslateDescription = function (District, lang, lang2, index) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/District/TranslateDescription?lang=" + lang + "&lang2=" + lang2 + "&index=" + index, District)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update Description 
    this.AddComment = function (Comment, objectId, lang) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/District/AddComment?id=" + objectId + "&lang=" + lang, Comment)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Save diffuseur
    this.SaveDiffuseur = function (Clients, objectId, lang) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/District/SaveDiffuseur?id=" + objectId + "&lang=" + lang, Clients)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }


    //Save adresses
    this.SaveAdressesAssociees = function (Places, objectId, lang) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/District/SaveAdressesAssociees?id=" + objectId + "&lang=" + lang, Places)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Save adresses
    this.SaveClassification = function (Classification, objectId, lang) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/District/SaveClassification?id=" + objectId + "&lang=" + lang, Classification)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Create New Description 
    this.CreateNewDescriptionForBio = function (descForCreation) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(descForCreation);
        var request = ApiService.post("/api/DescriptionApi/CreateNewDescriptionForObject/", st)
            .then(
                function success(data) {
                    $rootScope.returnNewDesc = angular.copy(data.data);
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Create
    this.CreateNewDistrict = function (DistrictVm) {
        var st = JSON.stringify(DistrictVm);
        var request = ApiService.post("/api/District/CreateNewDistrict", st);
        return request;
    }

    //GetDistrictForCreation
    this.GetDistrictForCreation = function (lang) {
        var request = ApiService.get("/api/District/GetDistrictForCreation?lang=" + lang);
        return request;
    }

    //GetDistrictPreview    
    this.GetDistrictPreview = function (id, lang) {
        var request = ApiService.get("/api/District/GetDistrictPreview?id=" + id + "&lang=" + lang);
        return request;
    }


    //Create New Description and associate with district
    this.CreateNewDescriptionForDistrict = function (descForCreation) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(descForCreation);
        var request = ApiService.post("/api/DescriptionApi/CreateNewDescriptionForObject/", st)
            .then(
                function success(data) {
                    $rootScope.returnNewDesc = angular.copy(data.data);
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }
});